import React, { useEffect, useMemo, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  Button,
  Icon,
  TextField,
  WithStyles,
  withStyles,
} from "@material-ui/core";

import { styles } from "./CRUDServicesStyles";

import * as actionCreators from "../../../store/actions";
import Loading from "../../UI/Loading/Loading";
import TableServices from "./TableServices/TableServices";
import EmptyTable from "./TableServices/EmptyTable";
import { NavLink } from "react-router-dom";
import IOSSwitch from "./IOSSwitch";
import useDebounce from "../../../hooks/use-debounce";
import AddIcon from "@material-ui/icons/Add";

const mapStateToProps = (state: any) => ({
  servicios: state.administracion.Servicios,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchApplications: (status: number) =>
    dispatch(actionCreators.GetApplications(status)),
  toggleActivationApplication: (id: number) =>
    dispatch(actionCreators.ToggleActivateApplication(id)),
  updateShowInMobile: (id: number, show: boolean) =>
    dispatch(actionCreators.UpdateShowInMobile(id, show)),
  updateShowInPanel: (id: number, show: boolean) =>
    dispatch(actionCreators.UpdateShowInPanel(id, show)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & WithStyles<typeof styles>;

const CRUDServices: React.FC<Props> = (props) => {
  const {
    classes,
    fetchApplications,
    toggleActivationApplication,
    updateShowInMobile,
    updateShowInPanel,
    servicios,
  } = props;
  const [_loading, setLoading] = useState(true);
  const [status, setStatus] = useState(1);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);

  const filteredServices = useMemo(() => {
    return servicios.filter((service: any) =>
      service.nombre.toLowerCase().includes(debouncedSearch.toLowerCase())
    );
  }, [debouncedSearch, servicios]);

  useEffect(() => {
    fetchApplications(status).then(() => setLoading(false));
  }, [fetchApplications, status]);

  const handleToggleActivationApplication = (id: number) => {
    toggleActivationApplication(id).then(() => {
      fetchApplications(status);
    });
  };
  const handleChangeMuestraMobile = (IdApplication: number, value: boolean) => {
    updateShowInMobile(IdApplication, value).then((resp: any) => {
      fetchApplications(status);
    });
  };
  const handleChangeMuestraPanel = (IdApplication: number, value: boolean) => {
    updateShowInPanel(IdApplication, value).then(() => {
      fetchApplications(status);
    });
  };

  return (
    <section className={classes.root}>
      <Loading loading={_loading} />
      <p className={classes.label}>
        Aquí podrás dar de alta servicios, consultar los disponibles y
        editarlos.
      </p>
      <div>
        <IOSSwitch
          id="servicios-status"
          name="servicios-status"
          onChange={() => setStatus((prev) => (prev === 1 ? 0 : 1))}
          checked={status === 0}
        />
        <label htmlFor="servicios-status" className={classes.label}>
          Ver aplicaciones inactivas
        </label>
      </div>
      <div className={classes.row}>
        <div className={classes.buttonContent}>
          <TextField
            name="nombreServicio"
            label="Nombre Servicio"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className={classes.search}
            autoComplete="off"
          />
          <Button
            component={NavLink}
            to="/alta-servicio"
            className={classes.button}
          >
            <Icon>
              <AddIcon style={{ marginBottom: "8px" }} />
            </Icon>
            Nuevo Servicio
          </Button>
        </div>
      </div>
      {servicios.length > 0 ? (
        <TableServices
          services={filteredServices}
          onDeleteApp={handleToggleActivationApplication}
          onChangeMuestraMobile={handleChangeMuestraMobile}
          onChangeMuestraPanel={handleChangeMuestraPanel}
        />
      ) : (
        <EmptyTable />
      )}
    </section>
  );
};

export default connector(
  withStyles(styles)(CRUDServices)
) as React.ComponentType;
